module.exports = __webpack_public_path__ + "img/Fred.5a4bf921.png";